import { Link } from 'react-router-dom'

/** A step in the trail. The last one is where you are, and carries no link. */
export type Crumb = { label: string; to?: string }

/**
 * The path from the hub to the current page.
 *
 * Replaces the single back link, which only ever went up one level — no use on
 * a document sitting three deep inside a topic inside a department. Marked up
 * as an ordered list inside a labelled nav, which is what lets assistive
 * technology announce it as a trail rather than a row of loose links.
 *
 * Separators are drawn in CSS: they are punctuation between items, not content
 * anyone needs read out.
 */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  if (items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="crumbs">
      <ol className="crumbs__list">
        {items.map((crumb, i) => {
          const isCurrent = i === items.length - 1
          return (
            <li key={`${crumb.label}-${i}`} className="crumbs__item">
              {crumb.to && !isCurrent ? (
                <Link to={crumb.to} className="crumbs__link">{crumb.label}</Link>
              ) : (
                <span className="crumbs__here" aria-current={isCurrent ? 'page' : undefined}>
                  {crumb.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
